document.addEventListener('DOMContentLoaded', function () {
  function syncStickyButton() {
    var mainButton = document.querySelector('.whatsapp-service-button');
    var stickyButton = document.querySelector('sticky-add-to-cart [ref="addToCartButton"]');

    if (!mainButton || !stickyButton) return;

    try {
      // Copiar el texto
      var mainTextEl = mainButton.querySelector('.add-to-cart-text__content');
      var stickyTextEl = stickyButton.querySelector('.add-to-cart-text__content');
      if (mainTextEl && stickyTextEl) {
        stickyTextEl.innerText = mainTextEl.innerText.trim();
      }

      // Redirigir click al enlace de WhatsApp
      stickyButton.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.open(mainButton.getAttribute('href'), '_blank');
      };
    } catch(err) {
      console.warn('sticky-bar-fix error:', err);
    }
  }

  // Esperar un poco para que la barra flotante cargue
  setTimeout(syncStickyButton, 800);

  // Re-ejecutar si cambia la variante
  document.addEventListener('theme:variant:update', function() {
    setTimeout(syncStickyButton, 400);
  });
});